import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

/**
 * ① メール内リンク
 *    https://analysis.jrpo.jp/reset-password-callback#access_token=...
 *
 * ② このページで Supabase のセッションを復元し、
 *    本来の /reset-password へ送り返す
 */
export default function ResetPasswordCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const restoreSession = async () => {
      console.log('🟦 セッション復元処理を開始します');
      console.log('🔍 現在のURL:', window.location.href);

      try {
        // ────────────────────────────────
        // 1) URL からセッション情報を取り出して保存
        // ────────────────────────────────
        const { data, error } = await supabase.auth.exchangeCodeForSession(window.location.href);

        console.log('🟩 セッション復元結果:', { data, error });

        if (error) {
          console.error('❌ セッション復元失敗:', error.message);
          // 失敗したらログイン画面へ逃がすなど
          navigate('/login', { replace: true });
          return;
        }

        // Store tokens in localStorage for future use
        try {
          if (data.session) {
            localStorage.setItem('auth_access_token', data.session.access_token);
            localStorage.setItem('auth_refresh_token', data.session.refresh_token);
            localStorage.setItem('auth_token_stored_at', new Date().toISOString());
            console.log('Stored tokens from callback session');
          }
        } catch (e) {
          console.error('Failed to store tokens:', e);
        }

        // ────────────────────────────────
        // 2) 復元が終わったら /reset-password ページへ移動
        //    ※ 300ms 待つのは localStorage への書き込み完了を
        //      ほぼ確実に待つための "ゆるい" ディレイ
        // ────────────────────────────────
        setTimeout(() => {
          console.log('🔄 /reset-password に遷移します');
          navigate('/reset-password?type=recovery', { replace: true });
        }, 300);
      } catch (error) {
        console.error('❌ セッション復元処理でエラー:', error);
        navigate('/reset-password?type=recovery', { replace: true });
      }
    };

    restoreSession();
  }, [navigate]);

  // ユーザーには "読み込み中" を表示
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-primary-50 to-primary-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-xl p-8">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              認証情報を処理中...
            </h2>
            <p className="text-gray-600">
              しばらくお待ちください
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}